module.exports = __webpack_public_path__ + "static/img/logo__.bc6f044.png";


//////////////////
// WEBPACK FOOTER
// ./src/brands/ice/logo__.png
// module id = zLZP
// module chunks = 1